import { Box, Grid, Typography } from '@mui/material';
import React, { useState } from 'react';
import { IoDocumentTextOutline } from 'react-icons/io5';
import DocPreview from '../FeedMediaView/DocPreview';

const FeedDocView = ({ docList }) =>
{
	const [ isOpen, setIsOpen ] = useState(false);
	const [ currentIndex, setCurrentIndex ] = useState(0);

	// const [ document, setDocument ] = useState({});

	const openModal = (ind) =>
	{
		// setDocument({ url, title });
		setIsOpen(true);
		setCurrentIndex(ind);
	};

	const closeModal = () =>
	{
		setIsOpen(false);
		// setDocument({});
	};

	return (
		<>
			{/* Display individual PDF file */}
			{docList.map((doc:any, ind) => (
				<Grid item key={ind} pt={1} xs={12} md={6} lg={4} spacing={1} pr='var(--pixel8)'>
					<Box sx={{ border: '1px solid var(--whiteD9)', borderRadius: '26px' }} p='var(--pixel8)' width='100%'>
						<Grid container justifyContent={'start'} direction={'row'} rowSpacing={1}>
							<Grid
								item
								pt='6px !important'
								display='flex'
								alignItems='center'
								flexDirection='row'
								onClick={() => openModal(ind)} // Trigger modal open on click
								sx={{ cursor: 'pointer' }}
								width='100%'
							>
								<Box

									component='img'
									src='\documents\pdf.png'
									width={'var(--pixel18)'}
									height={'var(--pixel18)'}
								/>
								{/* <Box color='#63AC64' display='flex' alignItems='center'>
									<IoDocumentTextOutline fontSize='var(--pixel18)'/>
								</Box> */}
								<Typography
									pl='var(--pixel8)'
									sx={{
										fontSize     : 'var(--pixel16)',
										color        : '#616161',
										fontWeight   : '400',
										textOverflow : 'ellipsis',
										// maxWidth     : 'var(--font200)',
										whiteSpace   : 'nowrap',
										overflow     : 'hidden'

									}}
								>
									{doc?.name}
								</Typography>
							</Grid>
						</Grid>
					</Box>
				</Grid>))
			}
			{/* {docList?.length > 0 && (
				<Grid item xs={12} my='var(--pixel8)'>
					<FeedMediaView mediaData={docList} limit={4} />
				</Grid>
			)} */}
			<DocPreview
				key={currentIndex}
				open={isOpen}
				handleClose={closeModal}
				// media={mediaData.map((media:any) =>
				// 	({ id: media?._id, img: media?.url, name: media?.name })
				// )}
				mediaList={docList}
				currentIndex={currentIndex}
				setCurrentIndex={setCurrentIndex}
			/>
			{/* PreviewModal component for viewing documents */}
			{/* <FeedDocPreview
				open={isOpen}
				handleClose={closeModal}
				// images={[]}
				currentIndex={0}
				setCurrentIndex={() => {}}
				document={file}
			// /> */}
		</>
	);
};

export default FeedDocView;

//  {/* PreviewModal component for viewing documents */}
//  <PreviewModal
//  open={isOpen}
//  handleClose={closeModal}
//  images={[]} // Empty images array because we are using docsource
//  currentIndex={0}
//  setCurrentIndex={() => {}} // No need to change index for single PDF view
//  document={document} // Pass the dynamic document URL here
// />